export const blockIconsPhotoandimageNavigateBeforeNew = (
	<span className='material-symbols-outlined'>navigate_before</span>
);
